var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_205_1",
    "data-name": "Component 205 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2176",
    "data-name": "Ellipse 2176",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#f7f3ed"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24040",
    "data-name": "Group 24040",
    transform: "translate(-320.5 -41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20952",
    "data-name": "Group 20952",
    transform: "translate(333.5 54)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_4644",
    "data-name": "Line 4644",
    x2: 14,
    y2: 13.5,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_4645",
    "data-name": "Line 4645",
    y1: 13.5,
    x2: 14,
    transform: "translate(333.5 54.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossNew);
export default __webpack_public_path__ + "static/media/cross_new.8f06c498bb3d3117c55a10aa210b7109.svg";
export { ForwardRef as ReactComponent };